import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, ArrowLeft, Send } from "lucide-react";
import Emblem from "@/components/Emblem";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";

const input = "w-full rsp-card pl-10 pr-3 py-3 bg-[var(--rsp-card)] outline-none focus:border-[var(--rsp-gold)] text-sm";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email, base_url: window.location.origin });
      setSent(true);
    } catch (err) {
      toast.error(apiError(err, "Could not send reset email."));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex justify-center bg-[var(--rsp-bg)]">
      <div className="w-full max-w-[440px] px-6 flex flex-col items-center text-center pt-16 pb-12">
        <Emblem size={120} />
        <div className="eyebrow mt-4" style={{ letterSpacing: "0.28em" }}>Password Reset</div>
        <h1 className="heading gold" style={{ fontSize: "2.4rem" }}>Forgot Password</h1>

        {sent ? (
          <div className="w-full mt-6 rsp-card p-6 space-y-3" data-testid="forgot-sent">
            <p className="text-[var(--rsp-cream)]">If an account exists for <span className="gold">{email}</span>, we've sent a password reset link.</p>
            <p className="text-[var(--rsp-gray)] text-sm">Check your inbox (and spam). The link expires in 1 hour.</p>
            <Link to="/login" className="btn-gold inline-flex items-center gap-2 px-5 py-2.5 mt-2" data-testid="back-to-login">
              <ArrowLeft size={16} /> Back to Sign In
            </Link>
          </div>
        ) : (
          <>
            <p className="text-[var(--rsp-gray)] text-sm mt-1 mb-6">Enter your email and we'll send you a secure link to reset your password.</p>
            <form onSubmit={submit} className="w-full space-y-3" data-testid="forgot-form">
              <div className="relative">
                <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--rsp-muted)]" />
                <input className={input} type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email" />
              </div>
              <button type="submit" disabled={busy} className="btn-gold w-full py-3 flex items-center justify-center gap-2 disabled:opacity-60" data-testid="forgot-submit">
                <Send size={16} /> {busy ? "Sending…" : "Send Reset Link"}
              </button>
            </form>
            <Link to="/login" className="text-sm text-[var(--rsp-gray)] hover:text-[var(--rsp-cream)] mt-5 inline-flex items-center gap-1" data-testid="forgot-back">
              <ArrowLeft size={14} /> Back to Sign In
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
